export const getPreviewFile = (file, parentId) => (Object.assign(Object.assign({}, file), { parentId, previewType: 'file' }));
